export const BUTTON_PROPS = {
  label: 'New',
  variant: 'solid',
  left: true,
  icon: 'plus',
  size: 40,
};
